import { use, useDebugValue } from 'react';

import { getLocaleFormat, getShortFormat, getStringAsCurrency } from '@Sage/ssm-utils';
export default function Currency(params) {
    const otherFields = params.otherFields ?? params.colDef?.cellRendererParams?.otherFields ?? {};
    const locale = params.locale ?? params.colDef?.cellRendererParams?.locale ?? '';
    let { value } = params;
    if (!value && value !== 0) return null;

    //TODO use currencyFromData and currencyFromLocale and depending on that,
    //use the data currency or get the currencyISO from locale in order to get the right symbol

    let finalValue = value;
    const currencySymbol = params.data?.[otherFields?.symbol] ?? '';

    const currencyCell = document.createElement('div');
    currencyCell.classList.add('w5-currency-cell');

    if (!finalValue) finalValue = 0;

    let digits = otherFields?.digits;
    if (typeof digits === 'function') {
        digits = digits(params.data, params);
    }

    let minDigits = otherFields?.minimumFractionDigits;
    if (typeof minDigits === 'function') {
        minDigits = minDigits(params.data, params);
    }
    if (minDigits === undefined) minDigits = digits !== undefined ? digits : 2;

    if (otherFields?.longFormat) {
        finalValue = getLocaleFormat(finalValue, locale, {
            minimumFractionDigits: minDigits,
            maximumFractionDigits: digits,
            useDebugValue: true,
        });
    } else {
        finalValue = getShortFormat(finalValue, locale, digits);
    }

    finalValue = getStringAsCurrency(finalValue, currencySymbol);
    currencyCell.innerText = finalValue;
    return currencyCell;
}
